import NoProgramPlaceholder from '@/components/tv/components/program/NoProgramPlaceholder'
import { getCurrentProgram } from '@/components/tv/helpers/getCurrentProgram'
import Program from '@/shared/classes/epg/program/program'
import { isProgram } from '@/shared/lib'
import { Box, Typography, useTheme } from '@mui/material'
import * as React from 'react'

import { ProgressBar } from '@/features/ProgressBar/ui/ProgresBar'
import BaseChannel from '@/shared/classes/tv/BaseChannel'

type Props = {
    programs: Program[]
    channel: BaseChannel
}

export const CurrentProgram = ({ programs = [], channel }: Props) => {
    const {
        currentProgram,
        programDurationProgress,
        programFormattedDuration,
    } = getCurrentProgram(programs)

    const theme = useTheme()

    const { lcn: channelNumber, name: channelName } = channel

    return (
        <Box width="100%">
            <Box ml="12px" display="flex" width="100%">
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    height="100%">
                    <Typography
                        typography={{ xs: 'text3', md: 'text2' }}
                        color="white"
                        width="100%">
                        {`${channelNumber}. ${channelName}`}
                    </Typography>
                    {currentProgram ? (
                        <Box
                            display="flex"
                            flexDirection="column"
                            height="100%"
                            mt="8px">
                            <Typography
                                variant="text2"
                                maxWidth="240px"
                                color={theme.palette.gray}>
                                {isProgram(currentProgram).name}
                            </Typography>

                            <Box
                                display="flex"
                                columnGap="10px"
                                alignItems="center">
                                <Typography
                                    mt="7px"
                                    variant="text3"
                                    width="max-content"
                                    color={theme.palette.gray}>
                                    {programFormattedDuration}
                                </Typography>

                                {programDurationProgress < 100 &&
                                    programDurationProgress !== 0 && (
                                        <Box
                                            maxWidth="60%"
                                            width="100%"
                                            mt="7px">
                                            <ProgressBar
                                                value={programDurationProgress}
                                                min={1}
                                                max={100}
                                                width={100}
                                            />
                                        </Box>
                                    )}
                            </Box>
                        </Box>
                    ) : (
                        <NoProgramPlaceholder
                            sx={{
                                color: theme.palette.gray,
                            }}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    )
}
